import apiSlice from "../api/apiSlice";

export const assignmentApi = apiSlice.injectEndpoints({
  
  endpoints: (builder) => ({
    getAssignments: builder.query({
      query: () => "/assignments",
    }),
    getAssignment: builder.query({
      query: (id) => `/assignments/${id}`,
    }),
    getAssignmentByVideoId: builder.query({
      query: (id) => `/assignments?video_id=${id}`,
      providesTags: (result, error, arg) => [
        {type: "AssignmentByVideoId", id: arg}
      ]
    }),
    addAssignment: builder.mutation({
      query: (data) => ({
        url: "/assignments",
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [
        {type: "AssignmentByVideoId", id: result.video_id}
      ],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: addedAssignment } = await queryFulfilled;

          dispatch(
            apiSlice.util.updateQueryData(
              "getAssignments",
              undefined,
              (draft) => {
                return (draft = [...draft, addedAssignment]);
              }
            )
          );
        } catch {}
      },
    }),
    editAssignment: builder.mutation({
      query: ({ data, id }) => ({
        url: `/assignments/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [
        {type: "AssignmentByVideoId", id: result.video_id}
      ],
      async onQueryStarted({ id, data }, { queryFulfilled, dispatch }) {
        try {
          const { data: updatedAssignment } = await queryFulfilled;

          dispatch(
            apiSlice.util.updateQueryData(
              "getAssignments",
              undefined,
              (draft) => {
                const targetedAssignment = draft.find(
                  (assignment) => assignment.id == updatedAssignment.id
                );
                Object.assign(targetedAssignment, updatedAssignment)
              }
            )
          );
        } catch {}
      },
    }),
    deleteAssignment: builder.mutation({
        query: (id) => ({
            url: `/assignments/${id}`,
            method: "DELETE"
        }),
        async onQueryStarted(arg, {queryFulfilled, dispatch}){
            const patchResult = dispatch(apiSlice.util.updateQueryData("getAssignments", undefined, (draft) => {
                return draft.filter((assignment) => assignment.id != arg);
            }))

            try{
                await queryFulfilled
            }catch{
                patchResult.undo()
            }
        }
    }),
    getAssignmentMarks: builder.query({
      query: () => `/assignmentMark`,
    }),
    getAssignmentMarksByStudentId: builder.query({
      query: (student_id) => `/assignmentMark?student_id=${student_id}`,
      providesTags: (result, error, arg) => [
        {type: "AssignmentByStudentId", id: arg}
      ]
    }),
    submitAssignmentMark: builder.mutation({
      query: (data) => ({
        url: "/assignmentMark",
        method: "POST",
        body: data
      }),
      invalidatesTags: (result, error, arg) => [
        {type: "AssignmentByStudentId", id: arg.student_id}
      ]
    }),
    sentAssignmentMark: builder.mutation({
      query: ({ id, data }) => ({
        url: `assignmentMark/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data: updatedMark } = await queryFulfilled;

          // update list after sending assignment mark
          dispatch(
            apiSlice.util.updateQueryData(
              "getAssignmentMarks",
              undefined,
              (draft) => {
                const targetedAssignment = draft.find(
                  (assignment) => assignment.id == updatedMark.id
                );

                Object.assign(targetedAssignment, updatedMark);
              }
            )
          );
        } catch (err) {}
      },
    }),
  }),
});

export const {
  useGetAssignmentMarksQuery,
  useGetAssignmentsQuery,
  useGetAssignmentByVideoIdQuery,
  useAddAssignmentMutation,
  useSentAssignmentMarkMutation,
  useGetAssignmentQuery,
  useEditAssignmentMutation,
  useDeleteAssignmentMutation,
  useGetAssignmentMarksByStudentIdQuery,
  useSubmitAssignmentMarkMutation
} = assignmentApi;
